import { EMPTY_APPLICATION_STATE, MOQ_FACET_KEY } from '../constants';
import { Attribute } from '../clients/DiscoveryPagesService';
import { MsxProduct } from '../clients/MsxService';
import { ApplicationState, TagSelection } from '../model/ApplicationState';
import { Category } from '../model/Category';
import { ScopeDefinition, AttributeFilter, ProductFilter, CategoryFilter, FacetFilter } from '../model/ScopeDefinition';
import { fromMetadataKey } from '../helper/tagKeyConverter';

export const mapToApplicationState = (scopeDefinition: ScopeDefinition): ApplicationState => {
  try {
    const defaultScope = scopeDefinition.default;

    const applicationState = {
      categories: defaultScope.categories?.map(mapCategory),
      products: defaultScope.products?.map(mapProduct),
      attributes: defaultScope.attributes?.map(mapAttributeFilter),
      tags: defaultScope.facets?.filter((f) => f.key !== MOQ_FACET_KEY).map(mapFacetToTag) ?? [],
      moq: defaultScope.facets?.some((f) => f.key === MOQ_FACET_KEY) ?? false,
      useOldScope: defaultScope.useOldScope,
      useCsvProductInput: defaultScope.useCsvProductInput ?? false,
    };
    return applicationState;
  } catch {
    console.warn('Error mapping scope definiton, returning empty application state');
    return EMPTY_APPLICATION_STATE;
  }
};

const mapAttributeFilter = (attributeFilter: AttributeFilter): Attribute => {
  return {
    name: attributeFilter.key,
    values: attributeFilter.selectedValues,
  };
};

const mapCategory = (category: CategoryFilter): Category => {
  const oldCategory = category as any;
  if (isOldFormat(oldCategory)) {
    return {
      id: oldCategory.key,
    };
  }

  return {
    id: category.categoryId,
  };
};

const mapProduct = (product: ProductFilter): MsxProduct => {
  return {
    mpvId: product.value,
    productKey: '',
  };
};

const isOldFormat = (oldCategory: any): boolean => {
  return 'key' in oldCategory;
};

const mapFacetToTag = (facet: FacetFilter): TagSelection => {
  return {
    name: fromMetadataKey(facet.key),
    value: facet.value === true || facet.value === 'true',
  };
};
